import React from 'react';

const PayPalIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg 
    viewBox="0 0 24 24" 
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6"
    {...props}
  >
    <path d="M7.05791 6.13636C7.54576 5.22727 8.52146 4 10.2221 4H16.9959C17.4838 4 17.8807 4.39695 17.8807 4.8848V5.62879C17.8807 5.8947 17.7022 6.13864 17.4583 6.22727L14.5226 7.18182C14.3641 7.22727 14.2235 7.37955 14.1918 7.54545L13.2049 13.0606L12.9199 14.7348C12.8744 15.0121 12.6305 15.2273 12.3532 15.2273H8.5332L7.33096 11.25L7.05791 6.13636Z" fill="#253B80"></path>
    <path d="M8.76184 8.13636C9.24969 7.22727 10.2254 6 11.926 6H18.6998C19.1877 6 19.5846 6.39695 19.5846 6.8848V7.62879C19.5846 7.8947 19.4061 8.13864 19.1622 8.22727L16.2265 9.18182C16.068 9.22727 15.9274 9.37955 15.8957 9.54545L14.9088 15.0606L14.6238 16.7348C14.5783 17.0121 14.3344 17.2273 14.0571 17.2273H10.2371L10.0348 18.375C9.97134 18.7273 9.63044 19 9.25316 19H6.18271C5.73878 19 5.38589 18.6606 5.32241 18.2197L4.01918 8.88636C3.96744 8.48939 4.28612 8.13636 4.69487 8.13636H8.76184Z" fill="#169BD7"></path>
  </svg>
);

export default PayPalIcon;
